<template>
  <router-link class="nav-link side-link" :to="to" v-bind="$attrs">
    <div
      class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text ms-1"
      >{{ navText }}</span
    >
  </router-link>
</template>
<script>
export default {
  name: "sidenav-collapse",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>

<style scoped>
.navbar-vertical .navbar-nav .nav-link {
  font-weight: 700;
}
.navbar-vertical .navbar-nav .nav-link.active {
  font-weight: 800;
}

.side-link:not(.active):hover {
  background: #ecf2ff;
  color:#2563eb !important;
  border-radius: 0.5rem;
}

.side-link.active:hover {
  transform: scale(1.02);
  transition: transform 0.3s ease;
}

</style>